import React from 'react';
import { GroupDetailsData } from '../types';
import { getAccessLevelIcon } from '../helpers';
import styles from '../../../../../../styles/OverviewTab.module.css';

interface GroupInfoCardProps {
  groupDetails: GroupDetailsData;
}

const GroupInfoCard: React.FC<GroupInfoCardProps> = ({ groupDetails }) => {
  return (
    <div className={styles.groupInfoCard}>
      <div 
        className={styles.groupBanner}
        style={{
          backgroundImage: `url(${groupDetails.banner || groupDetails.logo || '/images/groupsdefaultbaner.png'})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
      </div>
      
      <div className={styles.groupProfileSection}>
        <div className={styles.groupAvatar}>
          {groupDetails.logo ? (
            <img src={groupDetails.logo} alt={groupDetails.name} />
          ) : (
            groupDetails.name.charAt(0).toUpperCase()
          )}
        </div>
        
        <div className={styles.groupDetails}>
          <div className={styles.groupNameSection}>
            <h2>{groupDetails.name}</h2>
            <div className={`${styles.groupStatusBadge} ${groupDetails.is_active ? styles.active : styles.inactive}`}>
              {groupDetails.is_active ? 'Active' : 'Inactive'}
            </div>
          </div>
          
          <p className={styles.groupDescription}>
            {groupDetails.description || 'No description provided'}
          </p>
          
          <div className={styles.groupMeta}>
            <div className={styles.metaItem}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              <span>{groupDetails.member_count} Members</span>
            </div>
            
            {groupDetails.team_lead && (
              <div className={styles.metaItem}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                </svg>
                <span>Lead: {groupDetails.team_lead.full_name}</span>
              </div>
            )}
            
            <div className={styles.metaItem}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <span>Created {new Date(groupDetails.created_at).toLocaleDateString()}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupInfoCard;

